<template>
    <div class="bracket-graph-frame bracket-graph-unavailable" :class="{ 'is-embedded': embedded }">
        <div class="notification is-warning is-light">
            {{ translate("page.public_brackets.bracket_unavailable") }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { inject } from "vue";
    import { translate } from "../../Common/translations";

    // Error fallback for the async graph-bracket chunk: shown when @vue-flow/core
    // fails to load (flaky network, stale deploy) so the user sees the same notice
    // the adapters use for a malformed payload instead of an endless spinner.
    // defineAsyncComponent renders error components without props, so the embedded
    // flag comes from a provide() in PublicBracketApp.vue.
    const embedded = inject<boolean>("bracketEmbedded", false);
</script>
